/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * ChangHeon Yoo (chyoo@rsupport.com)
 *
 * @description
 *
 * @created at Mon Apr 08 2024
 **/

import { forwardRef } from "react";

import { Button, Icon, TextField } from "@/frameworks/designStuff/components";
import { useIntersectionObserverWithRef } from "@/frameworks/libraries/hooks";

interface SearchProps extends React.ComponentProps<typeof TextField> {
	onClear?: () => void;
}

const SearchBar = forwardRef<HTMLInputElement, SearchProps>(
	({ autoFocus = true, onClear, ...rest }: SearchProps, ref) => {
		useIntersectionObserverWithRef<HTMLInputElement>(ref, ({ isIntersecting, intersectionRatio }) => {
			if (!isIntersecting && intersectionRatio > 0.9) {
				onClear?.();
			}
		});

		return (
			<TextField.Icon
				ref={ref}
				autoFocus={autoFocus}
				value={rest.value}
				leftIcon={<Icon name="Search24" size={24} />}
				rightIcon={
					(rest.value?.length || 0) > 0 ? (
						<Button.Icon
							type="button"
							name="Close24"
							size="medium"
							filled="transparent"
							onClick={() => {
								onClear?.();
							}}
						/>
					) : undefined
				}
				{...rest}
			/>
		);
	}
);
export default SearchBar;
